module.exports = __webpack_public_path__ + "img/gal-4.b5855052.jpg";